const KEY = "dlt_installed";
let deferred = null;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn());

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferred = e;
  localStorage.removeItem(KEY);
  emit();
});
window.addEventListener("appinstalled", () => {
  deferred = null;
  localStorage.setItem(KEY, "1");
  emit();
});

export const onPwaChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const canPrompt = () => !!deferred;
export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const detectBrowser = () => {
  const ua = navigator.userAgent;
  if (isIOS()) return "ios";
  const android = /android/i.test(ua);
  if (/SamsungBrowser/i.test(ua)) return "samsung";
  if (/MiuiBrowser|XiaoMi/i.test(ua)) return "miui";
  if (/OPR\/|Opera|OPX\//i.test(ua)) return android ? "opera-android" : "opera-desktop";
  if (/Firefox\//i.test(ua)) return android ? "firefox-android" : "firefox-desktop";
  if (/Edg(A)?\//i.test(ua)) return android ? "chrome-android" : "edge";
  if (/Chrome\//i.test(ua)) return android ? "chrome-android" : "chrome-desktop";
  return android ? "other-android" : "other-desktop";
};

export const isInstalled = async () => {
  if (isStandalone() || localStorage.getItem(KEY) === "1") return true;
  if (navigator.getInstalledRelatedApps) {
    try { return (await navigator.getInstalledRelatedApps()).length > 0; } catch { return false; }
  }
  return false;
};

export const promptInstall = async () => {
  if (!deferred) return "unavailable";
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  if (outcome === "accepted") localStorage.setItem(KEY, "1");
  emit();
  return outcome;
};
